export default __webpack_public_path__ + "static/artifakt-element-light-796c5d2f8ffa961220c5418d9a9c12bd.woff2";